import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gutter-y-s3"
}
const _hoisted_2 = ["id"]

import { nextTick, onMounted, ref, watch } from 'vue';
import { PortfolioFarm } from '@/sdk/entities/portfolioFarm';
import ControlPanelCollapse from '@/components/ControlPanelCollapse.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import TokenData from '@/views/pages/liquidity/single-side/components/TokenData.vue';
import TokenDeposit from '@/views/pages/liquidity/single-side/deposit/TokenDeposit.vue';
import { SingleSideToken } from '../models/single-side-token';
import { useRoute } from 'vue-router';
import InfoMessage from '@/components/InfoMessage.vue';
import { isMultichainToken } from '@/helpers/token.helper';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenListDeposit',
  props: {
    noFeeLimit: null,
    sortBy: null,
    sortDirection: null,
    tokens: null,
    farms: null
  },
  emits: ["send-transaction"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'send-transaction'): void;
}), expose: any, slots: any, attrs: any }) {




const route = useRoute();
const { t } = useI18n();

const isExpandedByToken = ref<Record<string, boolean>>({});

const onExpanded = (token: SingleSideToken, isExpanded: boolean) => {
  isExpandedByToken.value[token.id] = isExpanded;
};

const onSendTransaction = () => {
  emits('send-transaction');
};

const selectedTokenId = ref('');
const scrollToToken = tokenId => {
  const el = document.querySelector(`#t_${tokenId}`);
  el?.scrollIntoView({ block: 'center', behavior: 'smooth' });
};
watch(
  route,
  value => {
    selectedTokenId.value = value.params.id as string;
    if (selectedTokenId.value) {
      nextTick(() => scrollToToken(selectedTokenId.value));
    }
  },
  { immediate: true },
);

onMounted(() => {
  if (selectedTokenId.value) {
    scrollToToken(selectedTokenId.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.tokens.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tokens, (token) => {
            return (_openBlock(), _createElementBlock("div", {
              key: token.id,
              id: `t_${token.id}`
            }, [
              _createVNode(ControlPanelCollapse, {
                crosschain: token.isCrossChain,
                "onUpdate:expanded": ($event: any) => (onExpanded(token, $event)),
                "toggle-inline": "",
                expanded: selectedTokenId.value.includes(token.id)
              }, {
                "header-title": _withCtx(() => [
                  _createVNode(TokenIcon, {
                    "icon-src": token.portfolioToken.tokenIconUrl,
                    full: "",
                    symbol: token.portfolioToken.symbol
                  }, null, 8, ["icon-src", "symbol"])
                ]),
                "header-data": _withCtx(() => [
                  _createVNode(TokenData, {
                    token: token,
                    action: 'deposit'
                  }, null, 8, ["token"])
                ]),
                default: _withCtx(() => [
                  (_unref(isMultichainToken)(token.portfolioToken.symbol as string))
                    ? (_openBlock(), _createBlock(InfoMessage, {
                        key: 0,
                        type: "warning",
                        icon: "error",
                        "as-panel": "",
                        message: _unref(t)('singleSide.infoMessage.multichainToken'),
                        class: "mb-s3"
                      }, null, 8, ["message"]))
                    : _createCommentVNode("", true),
                  _createVNode(TokenDeposit, {
                    "is-show": isExpandedByToken.value[token.id] ?? false,
                    token: token,
                    farm: __props.farms[token.id],
                    onSendTransaction: onSendTransaction
                  }, null, 8, ["is-show", "token", "farm"])
                ]),
                _: 2
              }, 1032, ["crosschain", "onUpdate:expanded", "expanded"])
            ], 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})